module.exports = __webpack_public_path__ + "media/images/front/icon_trophy_gold-227385a96f3ccc5fc681bf03f2a5ee02.png";